<template>
    <div>
        <el-table
            ref="regulatory-bundle-table"
            v-loading="loadingBundles"
            :data="bundles"
            class="w-full"
            stripe
        >
            <!-- Information Column -->
            <el-table-column
                prop="sid"
                label="Information"
                width="320"
            >
                <template v-slot="scope">
                    <InformationColumn
                        :row="scope.row"
                        :show-email="true"
                        :show-address="true"
                        name-field="friendly_name"
                    />
                </template>
            </el-table-column>

            <!-- Timestamps Column -->
            <el-table-column
                label="Timestamps"
                width="140"
            >
                <template v-slot="scope">
                    <TimestampsColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Phone Numbers Column -->
            <el-table-column
                label="Phone Numbers"
                prop="incoming_numbers_count"
                width="150"
            >
                <template v-slot="scope">
                    <CountColumn
                        :value="scope.row.incoming_numbers_count"
                        :single-value="true"
                    />
                </template>
            </el-table-column>

            <!-- Type & End User Column -->
            <el-table-column
                label="Details"
                width="120"
            >
                <template v-slot="scope">
                    <div v-if="scope.row.number_type">
                        <p class="mb-0 font-weight-bold">Number Type:</p>
                        <p class="mb-0">{{ fixToUcFirst(scope.row.number_type) }}</p>
                    </div>
                    <div v-if="scope.row.end_user_type" class="mt-1">
                        <p class="mb-0 font-weight-bold">End User:</p>
                        <p class="mb-0">{{ fixToUcFirst(scope.row.end_user_type) }}</p>
                    </div>
                    <span v-if="!scope.row.number_type && !scope.row.end_user_type">-</span>
                </template>
            </el-table-column>

            <!-- Country Column -->
            <el-table-column
                label="Country"
                prop="iso_country"
                width="80"
            >
                <template v-slot="scope">
                    <span v-if="scope.row.iso_country">{{ scope.row.iso_country }}</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>

            <!-- Status Column -->
            <el-table-column
                label="Status"
                prop="status_name"
                width="80"
            >
                <template v-slot="scope">
                    <StatusColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Failure Reason Column -->
            <el-table-column
                label="Failure Reason"
                prop="failure_reason"
            >
                <template v-slot="scope">
                    <FailureReasonColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Actions Column -->
            <el-table-column
                label="Action"
                width="150"
            >
                <template v-slot="scope">
                    <div class="mt-1">
                        <el-tooltip
                            :disabled="canDeleteBundle(scope.row)"
                            content="Pending or In Review Regulatory Bundle cannot be deleted."
                        >
                            <el-button
                                type="danger"
                                size="mini"
                                class="btn-block"
                                @click="handleDeleteBundle(scope.row)"
                                :loading="loadingDeleteBundle.includes(scope.row.id)"
                                :disabled="!canDeleteBundle(scope.row)"
                            >
                                Delete
                            </el-button>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import InformationColumn from '../columns/information-column'
import TimestampsColumn from '../columns/timestamps-column'
import StatusColumn from '../columns/status-column'
import FailureReasonColumn from '../columns/failure-reason-column'
import CountColumn from '../columns/count-column'
import * as ComplianceBundleStatuses from '../../../constants/compliance-bundle-statuses'
import { compliance_mixin } from '../../../mixins'

export default {
    name: 'RegulatoryBundleTable',
    mixins: [compliance_mixin],
    components: {
        InformationColumn,
        TimestampsColumn,
        StatusColumn,
        FailureReasonColumn,
        CountColumn,
    },
    props: {
        bundles: {
            type: Array,
            required: true,
        },
        loadingBundles: {
            type: Boolean,
            required: true,
        },
        company: {
            type: Object,
            required: true,
        },
        loadingUpdateBundle: {
            type: Array,
            default: () => [],
        },
        loadingDeleteBundle: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        canDeleteBundle(bundle) {
            // Pending or In Review Regulatory Bundle cannot be deleted
            return ![ComplianceBundleStatuses.STATUS_PENDING, ComplianceBundleStatuses.STATUS_IN_REVIEW].includes(bundle.status)
        },
        handleDeleteBundle(bundle) {
            this.$emit('delete-bundle', bundle)
        },
    },
}
</script>
